import { render, staticRenderFns } from "./allNews.vue?vue&type=template&id=3e3f92c6&scoped=true"
import script from "./allNews.vue?vue&type=script&lang=js"
export * from "./allNews.vue?vue&type=script&lang=js"
import style0 from "./allNews.vue?vue&type=style&index=0&id=3e3f92c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3f92c6",
  null
  
)

export default component.exports